<template>
    <div class="container">
      <Header />
      <Caculator />
      <Footer />
    </div>
</template>

<script setup>
import Header from './components/Header.vue'
import Caculator from './components/Caculator.vue'
import Footer from './components/Footer.vue'
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color:rgb(30, 30, 30);
  width: 100%;
  height: 100%;
}
</style>
